const bokeh = {
  directiveName: 'bokeh',

  bind: (el, {value}) => {
    const callback = value;

    el.bokehHandler = (e) => {
      if (el.contains(e.target)) {
        return;
      }

      callback();
    };

    document.documentElement.addEventListener('click', el.bokehHandler);
  },

  unbind: (el) => {
    document.documentElement.removeEventListener('click', el.bokehHandler);
  }
};

module.exports = bokeh;



// WEBPACK FOOTER //
// ./node_modules/tortilla/src/components/bokeh/bokeh.js